<div class="litmus-feed-list-controls">
  <div class="litmus-left-controls">
    <div class="litmus-feed-controls">
      <div class="">
        <button type="button" class="btn btn-primary">New Request</button>
      </div>
      <div class="litmus-feed-controls">
        <div class="litmus-refresh-feeds">
          <label for="refresh_feeds" (click)='refreshData()'>
            <img src="assets/images/refresh.svg" /> Refresh feeds
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="litmus-right-controls">
    <div style="line-height: 60px;">
      <button [ngClass]="default_selected_type == 'CFRA'? 'active' : ''" type="button" class="btn btn-outline-primary responded-btn" (click)="loadData('CFRA')">Responded</button>
      <button [ngClass]="default_selected_type == 'CFR'? 'active' : ''" type="button" class="btn btn-outline-primary non-responded-btn" (click)="loadData('CFR')">Not responded</button>
    </div>
    <div class="litmus-feed-filter" #litmusfeedsearch id="litmusfeedsearch">
      <div class="litmus-feed-filter-input">
        <img src="assets/images/magnify.svg">
        <div class="litmus-feed-input-field">
          <input [placeholder]="'Search by ' + defaultSelectedField.field_text" type="text" (keyup)="searchUserByType($event)" [(ngModel)]="searchText" (click)="toggleSearchList()" />
        </div>
        <button [class.hidden]="!isTextEntered" (click)="clearSearchBox()">
          <img class="clear-img" src="assets/images/close.svg">
        </button>
        <button (click)="toggleFilterFieldList()">
          <img src="assets/images/menu-down-dark.svg" />
        </button>
      </div>
      <ul id="litmus-search-list" *ngIf="showSearchList" class="litmus-feed-filter-list">
        <li *ngFor="let item of searchResult.options" (click)="searchListSelectedvalue(item)">
          {{item.displayText || item.text}}
        </li>
      </ul>
      <ul id="litmus-search-selector" *ngIf="showFilterFields" class="litmus-feed-filter-list">
        <li *ngFor="let item of searchAvailableOnList" (click)="changeFilterField(item)" [class.active]=" item.field_id == defaultSelectedField.field_id">
          {{item.field_text}}
        </li>
      </ul>
    </div>
    <div class="litmus-button-group" style="line-height: 9px;margin-top: 9px;">
      <button>
        <img src="assets/images/fullscreen.svg" />
      </button>
    </div>
    <div class="litmus-feed-list-paging">
      <button (click)="previous_page()" [disabled]="isFirstPage">
        <img src="assets/images/angle-left.svg" />
      </button>
      <span> {{show_data_count_from}} - {{total_count_of_data}} </span>
      <button (click)="next_page()" [disabled]="!isNext">
        <img src="assets/images/angle-right.svg" />
      </button>
    </div>
  </div>
</div>
<app-ltms-data-table-v2 [columns]="requestsJourneyHeader" [data]="prepared_responded_list" [errorCode]="errorCode"></app-ltms-data-table-v2>
